module.exports = __webpack_public_path__ + "img/responsive crc-05.a893d3c0.jpg";